import ChannelContext from '@jetshop/core/components/ChannelContext';
import { useContext } from 'react';
import { useIntl } from '@jetshop/intl';
// #endregion Interfaces
// #region
export function usePrice({ currencyOverride, price, previousPrice, includeVat, formatter: defaultFormatter, hidePrice }) {
    var _a;
    const context = useContext(ChannelContext);
    const t = useIntl();
    if (!context || !context.selectedChannel)
        return null;
    let formatter = defaultFormatter;
    if (!formatter) {
        formatter = t.number;
    }
    const { selectedChannel: { settings, currency, language } } = context;
    /** Get the locale to be passed to the t.price formatter */
    const currencyLocale = currencyOverride
        ? { code: currencyOverride.code, culture: currencyOverride.culture }
        : {
            code: currency.name,
            culture: language.culture
        };
    /** Allow incVat to be overriden */
    const incVat = typeof includeVat !== 'undefined'
        ? includeVat
        : (_a = settings === null || settings === void 0 ? void 0 : settings.pricesIncVat) !== null && _a !== void 0 ? _a : true;
    /** Convert the pricing to {value: number} */
    const pricing = {
        price: selectPriceType(incVat, price),
        previousPrice: previousPrice
            ? selectPriceType(incVat, previousPrice)
            : { value: 0, vat: 0 }
    };
    const formattedPricing = {
        previousPrice: null,
        price: null
    };
    for (const val in pricing) {
        if (pricing.hasOwnProperty(val) && pricing[val]) {
            formattedPricing[val] = formatter(pricing[val].value, currencyLocale.code, currencyLocale.culture);
        }
    }
    return {
        hidePrice,
        hasDiscount: pricing.previousPrice && pricing.previousPrice.value
            ? pricing.price.value < pricing.previousPrice.value
            : false,
        includesVat: incVat,
        currencyLocale,
        pricing,
        formattedPricing
    };
}
// #endregion Container Component
// #region Utilities
/**
 * Normalise the price to an object with keys `value` and `vat`
 */
export function selectPriceType(includeVat, priceObj) {
    if (!priceObj)
        return null;
    const { vat, exVat, incVat } = priceObj;
    if (includeVat) {
        return { vat, value: incVat };
    }
    return {
        vat,
        value: exVat
    };
}
// #endregion Utilities
//# sourceMappingURL=usePrice.js.map